// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { generateId, randomIntBetween } from './api/utility';
import { useGlobalState } from './globalState/GlobalStateProvider';

const Float = (rise, translation) => keyframes`
    0% { 
        bottom: -100px;
    }
    
    10% {  
        opacity 0.8;
    }
    90% {
        bottom: ${rise}vh;
        opacity 0;
        transform: translate(${translation}px, 0);
    }
    100% {
        bottom: -100px;
    }
`;

const Bubble = styled.div`
    display block;
    border-radius: 100%;
    opacity: 0;
    position absolute;
    z-index: 4;

    &:nth-child(${({ index }) => index}) {
        background: radial-gradient(ellipse at ${({ index }) => index % 2 === 0 ? 'top right' : 'center'}, #b8c6c6 0%,#30b3d3 46%,#20628c 100%);
        width: ${({ bubbleSize }) => bubbleSize}px;
        height: ${({ bubbleSize }) => bubbleSize}px;
        left: ${({ left }) => left}vw;
        bottom: ${({ bottom }) => bottom}vh;
        animation ${({ start, translation }) => Float(start, translation)} infinite ${({ time }) => time}s;
    }
`;


const Bubbles = ({ ...props }) => {
    const { state: {
        site_config,
    } } = useGlobalState();

    const [bubbles, setBubbles] = useState([])
    
    useEffect(() => {
        const res = []
        for (let i = 0; i < site_config.bubbles.number; i++) {
            const bubbleSize = randomIntBetween(5, 100);

            const left = randomIntBetween(1, 100);
            const bottom = randomIntBetween(1, 100);
            const time = randomIntBetween(3, 15);

            const start = randomIntBetween(50, 100)
            const translation = randomIntBetween(-100, 100)

            res.push(
                <Bubble
                    key={generateId()}
                    index={i + 1}
                    bubbleSize={bubbleSize}
                    left={left}
                    bottom={bottom}
                    time={time}

                    start={start}
                    translation={translation}
                />
            );
        }
        setBubbles(res)
    }, [])

    return <div>{bubbles}</div>;
}

export default Bubbles;
